import React, { useEffect, useState } from "react";
import style from "./chargeWallet.module.scss";
import Skeleton from "../../skeleton/skeleton"
{/* <Skeleton type='rectangle' width='280px' height='44px' /> */ }
const WalletSkeleton = (props) => {

    return <div className={style.wrapper}>
        <div className={style.header}>
            <h1><Skeleton type='rectangle' width='96px' height='44px' /></h1>
            <div className={style.buttonsWrapper}>
                <div className={style.settingButton}>
                    <Skeleton type='rectangle' width='150px' height='44px' />
                </div>
            </div>
        </div>

        <div className={style.chargeStatus}>
            <div className={style.chargeStatusItem} style={{ padding: '0', background: 'none' }}>
                <Skeleton type='rectangle' width='300px' height='100px' />
            </div>

            <div className={style.chargeStatusItem} style={{ padding: '0', background: 'none' }}>
                <Skeleton type='rectangle' width='300px' height='100px' />
            </div>
        </div>

        <p className={style.generalDescription}><Skeleton type='rectangle' width='200px' height='44px' /></p>
        <h5 className={style.recommendedPricesHeader}><h1><Skeleton type='rectangle' width='106px' height='44px' /></h1></h5>

    </div>
}
export default WalletSkeleton;
